import React, { useState, useEffect } from "react";
import useStyles from "../style";
import useStylesTable from "../../settings/styles";
import useStylesTravelerSwitch from "../../user/styles";
import config from "../../../config";
import axios from "axios";

// components
import { CircularProgress, Switch } from "@material-ui/core";
import Modal from "../../modals/Modal";
//import ModalCamera from "../../modals/ModalCamera";
import InputComponent from "./inputComponent";
import InputSelect from "./inputSelect";
import InputSelectMembershipType from "./inputSelectMembershipType";
import InputDisableAge from "../../user/components/inputDisableAge";
import { TextField } from "@material-ui/core";
import SwitchPrincipalPartner from "../../user/components/switch";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { RefreshRounded } from "@material-ui/icons";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import PayGroup from "../payGroup";
import SimpleImageInput from "../../user/components/simpleImageInput";

const AddGroupPartnerForm = ({ allGenders, allMembershipType, allPartnerType, allDays, costInscription, costTraveler, accessCountTraveler, groupType }) => {
  const classes = useStyles();
  const classesTable = useStylesTable();
  const classesTravelerSwitch = useStylesTravelerSwitch();

  const expressions = {
    usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
  }

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [name, setName] = useState({ text: '', valid: null });
  const [lastName, setLastName] = useState({ text: '', valid: null });
  const [birthdayDate, setBirthdayDate] = useState('');
  const [age, setAge] = useState('Edad');
  const [address, setAddress] = useState({ text: '', valid: null });
  const [image, setImage] = useState('');
  const [fingerPrint, setFingerPrint] = useState({ text: '', valid: null });
  const [phone, setPhone] = useState({ text: '', valid: null });
  const [email, setEmail] = useState({ text: '', valid: null });
  const [gender, setGender] = useState({ text: '', valid: null });
  const [membershipType, setMembershipType] = useState({ text: '', membershipValidity: 0, cost: 0, services: [], valid: null });
  const [partnerType, setPartnerType] = useState({ text: '', valid: null });
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [membershipValidity, setMembershipValidity] = useState(0);
  const [allFingerPrints, setAllFingerPrints] = useState([]);
  const [paidInscription, setPaidInscription] = useState(false);
  const [isTraveler, setIsTraveler] = useState(false);
  const [partnersToPay, setPartnersToPay] = useState([]);
  const [principalImage, setPrincipalImage] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isPricipalPartner, setIsPricipalPartner] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [partners, setPartners] = useState([]);
  const [idPartner, setIdPartner] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [idEdit, setIdEdit] = useState(0);
  const [calendarKey, setCalendarKey] = useState(0);
  const [startMembershipKey, setStartMembershipKey] = useState(0);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fechFingerPrints = async () => {
    if (!showModal) {
      fetch(baseUrl + "getTemplates",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setAllFingerPrints(data);
          }
        })
        .catch(error => null);
    }
  }

  useEffect(() => {
    fechFingerPrints();
  }, []);

  const onChangeDatePicker = (e) => {
    setBirthdayDate(e.target.value);

    var today = new Date();
    var birthDate = new Date(e.target.value);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    setAge(age);
  }

  const onTagsChange = (event, values) => {
    if (values != null) {
      setFingerPrint({ text: values.template, valid: "true" });
    } else {
      setFingerPrint({ text: '', valid: "false" });
    }
  }

  const handleChangeDays = (property) => (e) => {
    const value = e.target.value;
    var serviceLessSevenDays = false;

    membershipType.services.map((item) => {
      if (item.serviceName == property) {
        if (item.numberOfDays < 7) {
          serviceLessSevenDays = true;
        }
      }
    });

    if (!serviceLessSevenDays) {
      if (value[value.length - 1] === "all") {
        const allDaysList = [];

        allDays.map((option) => {
          allDaysList.push(option.name);
        });

        membershipType.services.map((item) => {

          if (item.serviceName == property) {
            var index = membershipType.services.indexOf(item);

            var servicesItem = {
              "serviceName": item.serviceName,
              "numberOfDays": item.numberOfDays,
              "days": item.days.length === allDays.length ? [] : allDaysList,
              "isAllSelected": item.days.length === allDays.length ? false : true
            };

            const allList = membershipType.services;
            allList[index] = servicesItem;
            setMembershipType({ ...membershipType, services: allList });
          }
        });
        return;
      }
      if (value != '') {
        membershipType.services.map((item) => {
          if (item.serviceName == property) {
            const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
            var index = membershipType.services.indexOf(item);

            var servicesItem = {
              "serviceName": item.serviceName,
              "numberOfDays": item.numberOfDays,
              "days": value,
              "isAllSelected": isAllSelected
            };

            const allList = membershipType.services;
            allList[index] = servicesItem;
            setMembershipType({ ...membershipType, services: allList });
          }
        });
        return;
      }

      membershipType.services.map((item) => {
        if (item.serviceName == property) {
          const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
          var index = membershipType.services.indexOf(item);

          var servicesItem = {
            "serviceName": item.serviceName,
            "numberOfDays": item.numberOfDays,
            "days": value,
            "isAllSelected": isAllSelected
          };

          const allList = membershipType.services;
          allList[index] = servicesItem;
          setMembershipType({ ...membershipType, services: allList });
        }
      });
    } else {
      if (value[value.length - 1] === "all") {
        return;
      }
      if (value != '') {
        membershipType.services.map((item) => {
          if (item.serviceName == property) {
            const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
            var index = membershipType.services.indexOf(item);

            var servicesItem = {
              "serviceName": item.serviceName,
              "numberOfDays": item.numberOfDays,
              "days": value,
              "isAllSelected": isAllSelected
            };

            if (value.length <= item.numberOfDays) {
              const allList = membershipType.services;
              allList[index] = servicesItem;
              setMembershipType({ ...membershipType, services: allList });
            }
          }
        });
        return;
      }

      membershipType.services.map((item) => {
        if (item.serviceName == property) {
          const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
          var index = membershipType.services.indexOf(item);

          var servicesItem = {
            "serviceName": item.serviceName,
            "numberOfDays": item.numberOfDays,
            "days": value,
            "isAllSelected": isAllSelected
          };

          if (value.length <= item.numberOfDays) {
            const allList = membershipType.services;
            allList[index] = servicesItem;
            setMembershipType({ ...membershipType, services: allList });
          }
        }
      });
    }
  }

  const handleChangeTraveler = event => {
    var value = event.target.checked;

    setIsTraveler(value);
    if (value) {
      setMembershipType({ ...membershipType, membershipValidity: accessCountTraveler });
    } else {
      setMembershipType({ ...membershipType, membershipValidity: membershipValidity });
    }
  };

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    var partnersToNextPage = [];
    var indexPost = 0;

    for (var i = 0; i < partners.length; i++) {
      var newPartner = partners[i];
      var allList = "[";
      if (newPartner.dayOfServices.length > 1) {

        for (var i = 0; i < newPartner.dayOfServices.length; i++) {
          var item = newPartner.dayOfServices[i];
          if (i == (newPartner.dayOfServices.length - 1)) {
            allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
          } else {
            allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}, ";
          }
        }
      } else {
        var item = newPartner.dayOfServices[0];
        allList = "[{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
      }

      var discount = 0;
      var subtotal = Number(newPartner.membershipCost);
      var total = 0;

      if (groupType.discount > 0) {
        if (groupType.isDiscountByPercent) {
          discount = ((Number(newPartner.membershipCost) * (Number(groupType.discount))) / 100);
        } else {
          discount = Number(groupType.discount);
        }

        if (newPartner.isTraveler) {
          subtotal = subtotal + costTraveler;
        }

        if (newPartner.paidInscription) {
          subtotal = subtotal + costInscription;
        }

        total = subtotal - discount;
      } else {
        if (newPartner.isTraveler) {
          subtotal = subtotal + costTraveler;
        }

        if (newPartner.paidInscription) {
          subtotal = subtotal + costInscription;
        }

        total = subtotal - discount;
      }

      const formData = new FormData();

      if (newPartner.file != null) formData.append("file", newPartner.file);
      formData.append("name", newPartner.name);
      formData.append("lastName", newPartner.lastName);
      formData.append("birthdayDate", newPartner.birthdayDate);
      formData.append("age", newPartner.age);
      formData.append("address", newPartner.address);
      formData.append("email", newPartner.email);
      formData.append("phone", newPartner.phone);
      formData.append("membershipType", newPartner.membershipType);
      formData.append("membershipValidity", newPartner.membershipValidity);
      formData.append("gender", newPartner.gender);
      formData.append("fingerPrint", newPartner.fingerPrint);
      formData.append("partnerType", newPartner.partnerType);
      formData.append("groupType", groupType.text);
      if (i == 0) {
        formData.append("isPartnerPrincipal", 1);
      } else {
        formData.append("isPartnerPrincipal", 0);
        formData.append("partnerPrincipalId", partnersToNextPage[0].id);
      }
      formData.append("accessCountMembership", Number(newPartner.membershipValidity));
      formData.append("accessCount", Number(newPartner.membershipValidity));
      formData.append("accessProId", 0);
      formData.append("isFree", newPartner.membershipCost > 0 ? 0 : 1);
      formData.append("paidInscription", newPartner.paidInscription);
      formData.append("dayOfServices", allList);
      formData.append("isTraveler", newPartner.isTraveler);

      await axios({
        method: "post",
        url: baseUrl + "createPartner",
        data: formData,
        headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
      })
        .then(function (response) {
          if (response.data.status == "Ok") {
            var partnerToPay = {
              "id": response.data.content,
              "name": newPartner.name + " " + newPartner.lastName,
              "membershipType": newPartner.membershipType,
              "groupType": groupType.text,
              "membershipCost": newPartner.membershipCost,
              "membershipDiscount": discount,
              "paidInscription": newPartner.paidInscription,
              "costInscription": costInscription,
              "isTraveler": newPartner.isTraveler,
              "costTraveler": costTraveler,
              "subtotal": subtotal,
              "totalPay": total,
              "change": 0.00,
              "valid": 'false',
              "payment": [],
              "paid": false
            }

            indexPost = indexPost + 1;
            partnersToNextPage.push(partnerToPay);
          } else {
            if (response.data.message == "Access is denied") {
              i = partners.length;
              setShowModal(true);
            }
          }
        })
        .catch(function (error) { });

      if (i == (partners.length - 1)) {
        setIsLoading(false);
        setPartnersToPay(partnersToNextPage);
      }
    }

    setIsLoading(false);
  }

  const onAddPartner = e => {
    if (isEdit) {
      setIsEdit(false);
      var item = {
        "id": idPartner,
        "file": principalImage,
        "name": name.text,
        "lastName": lastName.text,
        "birthdayDate": birthdayDate,
        "age": age == 'Edad' ? 0 : age,
        "address": address.text,
        "email": email.text,
        "phone": phone.text,
        "membershipType": membershipType.text,
        "membershipValidity": membershipType.membershipValidity,
        "membershipCost": membershipType.cost,
        "gender": gender.text,
        "fingerPrint": fingerPrint.text,
        "partnerType": partnerType.text,
        "groupType": groupType.text,
        "isPartnerPrincipal": isPricipalPartner == true ? 1 : 0,
        "accessCountMembership": Number(membershipType.membershipValidity),
        "accessCount": Number(membershipType.membershipValidity),
        "accessProId": 0,
        "isFree": membershipType.cost > 0 ? 0 : 1,
        "paidInscription": paidInscription == true ? 1 : 0,
        "dayOfServices": membershipType.services,
        "isTraveler": isTraveler == true ? 1 : 0
      };

      partners[idEdit] = item;
    } else {
      var item = {
        "id": idPartner,
        "file": principalImage,
        "name": name.text,
        "lastName": lastName.text,
        "birthdayDate": birthdayDate,
        "age": age == 'Edad' ? 0 : age,
        "address": address.text,
        "email": email.text,
        "phone": phone.text,
        "membershipType": membershipType.text,
        "membershipValidity": membershipType.membershipValidity,
        "membershipCost": membershipType.cost,
        "gender": gender.text,
        "fingerPrint": fingerPrint.text,
        "partnerType": partnerType.text,
        "groupType": groupType.text,
        "isPartnerPrincipal": isPricipalPartner == true ? 1 : 0,
        "accessCountMembership": Number(membershipType.membershipValidity),
        "accessCount": Number(membershipType.membershipValidity),
        "accessProId": 0,
        "isFree": membershipType.cost > 0 ? 0 : 1,
        "paidInscription": paidInscription == true ? 1 : 0,
        "dayOfServices": membershipType.services,
        "isTraveler": isTraveler == true ? 1 : 0
      };
      var list = partners;
      list.push(item);
      setPartners(list);
      setIdPartner(idPartner + 1);
    }

    setName({ text: '', valid: null });
    setLastName({ text: '', valid: null });
    setBirthdayDate('');
    setCalendarKey(calendarKey + 1);
    setStartMembershipKey(startMembershipKey + 1);
    setAge('Edad');
    setAddress({ text: '', valid: null });
    setPrincipalImage(null);
    setFingerPrint({ text: '', valid: null });
    setPhone({ text: '', valid: null });
    setEmail({ text: '', valid: null });
    setGender({ text: '', valid: null });
    setMembershipType({ text: '', membershipValidity: 0, cost: 0, services: [], valid: null });
    setMembershipValidity(0);
    setPartnerType({ text: '', valid: null });
    setPaidInscription(false);
    setIsTraveler(false);

    setAutocompleteKey(autocompleteKey + 1);
    fechFingerPrints();
  }

  const onDelete = (id) => e => {
    e.preventDefault();
    var index = -1;

    partners.map((item) => {
      if (item.id == id) {
        index = partners.indexOf(item);
      }
    });

    if (index > -1) {
      var list = [];
      for (var i = 0; i < partners.length; i++) {
        var item = partners[i];
        if (index != i) {
          list.push(item);
        }
      }
      setPartners(list);
    }
  }

  const onEdit = (id) => e => {
    e.preventDefault();
    setIsEdit(true);

    var item;
    for (var i = 0; i < partners.length; i++) {
      var partner = partners[i];
      if (partner.id == id) {
        item = partner;
        setIdEdit(i);
      }
    }

    setName({ text: item.name, valid: item.name != '' ? 'true' : null });
    setLastName({ text: item.lastName, valid: item.lastName != '' ? 'true' : null });
    setBirthdayDate(birthdayDate);
    setAge(age == 0 ? 'Edad' : age);
    setAddress({ text: item.address, valid: item.address != '' ? 'true' : null });
    setPrincipalImage(item.file);
    setFingerPrint({ text: item.fingerPrint, valid: 'true' });
    setPhone({ text: item.phone, valid: item.phone != '' ? 'true' : null });
    setEmail({ text: item.email, valid: item.email != '' ? 'true' : null });
    setGender({ text: item.gender, valid: item.gender != '' ? 'true' : null });
    setMembershipType({
      text: item.membershipType, membershipValidity: item.membershipValidity, cost: item.membershipCost,
      services: item.dayOfServices, valid: item.membershipType != '' ? 'true' : null
    });
    setMembershipValidity(item.membershipValidity);
    setPartnerType({ text: item.partnerType, valid: item.partnerType != '' ? 'true' : null });
    setPaidInscription(item.paidInscription == 1 ? true : false);
    setIsTraveler(item.isTraveler == 1 ? true : false);
  }

  function currencyFormat(num) {
    return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  return (
    <div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      {partnersToPay.length > 0 ? (
        <>
          <PayGroup
            partners={partnersToPay}
          />
        </>
      ) : (
        <>
          {partners.map((item) => (
            <div style={{ display: "inline-block" }}>
              <div className={classes.cardPartnerGroup}>
                <div className={classes.cardLabel} onClick={onEdit(item.id)}>
                  <p style={{ fontSize: "18px", paddingTop: "10%" }}>{item.name}</p>
                </div>
                <div className={classes.divActionButtonDisable} >
                  <Delete
                    classes={{ root: isEdit ? classes.activeButtonDisable : classes.searchIcon }}
                    onClick={isEdit ? null : onDelete(item.id)}
                  />
                </div>
              </div>
            </div>
          ))}

          <div className={classes.div} >
            <div className={classes.divTitle}>
              <label className={classes.titleStyle}>Agregar socio</label>
            </div>

            <div className={classes.divColumn} >
              <InputComponent
                text={name}
                setPartnerCode={setName}
                type="text"
                label="Nombres"
                name="name"
                regularExpression={expressions.nombre}
                placeholder="Nombre"
                isRequired={true}
              />

              <InputComponent
                text={lastName}
                setPartnerCode={setLastName}
                type="text"
                label="Apellidos"
                name="lastName"
                regularExpression={expressions.nombre}
                placeholder="Apellidos"
                isRequired={true}
              />

              <div className={classes.divDate}>
                <label className={classes.labelDate} >Fecha de nacimiento</label>
                <TextField
                  key={calendarKey}
                  type="date"
                  defaultValue="2003-10-22"
                  className={classes.inputDate}
                  onChange={onChangeDatePicker}
                  style={{ width: '85%' }}
                  inputStyle={{ width: '85%' }}
                />
              </div>

              <InputDisableAge
                value={age}
                type="text"
                label="Edad"
                name="age"
                placeholder="18 años"
              />

              <SimpleImageInput
                text={principalImage}
                setValue={setPrincipalImage}
                label={"Foto del socio"}
              />

              <InputComponent
                text={address}
                setPartnerCode={setAddress}
                type="text"
                label="Dirección"
                name="address"
                regularExpression={expressions.texto}
                placeholder="Calle primera, 1234, Centro"
              />

              <InputComponent
                text={phone}
                setPartnerCode={setPhone}
                type="text"
                label="Teléfono"
                name="phone"
                regularExpression={expressions.numbers}
                placeholder="6688888888"
                isRequired={false}
              />

              <InputComponent
                text={email}
                setPartnerCode={setEmail}
                type="text"
                label="Correo electrónico"
                name="email"
                regularExpression={expressions.email}
                placeholder="correo@ejemplo.com"
                isRequired={false}
              />

              <InputSelect
                text={gender}
                setValue={setGender}
                label={"Género"}
                options={allGenders}
              />

              {/*<div>
            <label className={classes.label} >Foto del usuario</label>
            <button
              className={classes.enableButtonFinger}
              onClick={openModalCamera}>
              Tomar foto
            </button>
            <ModalCamera
              isOpen={isOpenModalCamera}
              closeModal={closeModalCamera}
              setPhoto={setImage}
            />
          </div>*/}

              <div>
                <div className={classes.divLabel}>
                  <p className={classes.label} >Huella digital</p>
                  <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                </div>

                <div className={classes.divHeader} >
                  <div className={classes.searchDivFullWidthWithoutShadow} >
                    <Autocomplete
                      key={autocompleteKey}
                      options={allFingerPrints}
                      getOptionLabel={option => option.code}
                      onChange={onTagsChange}
                      className={classes.inputSearchFinger}
                      openText={"Abrir"}
                      closeText={"Cerrar"}
                      clearText={"Limpiar"}
                      noOptionsText={"Sin resultados"}
                      renderInput={params => (
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder={"Buscar huella digital"}
                          fullWidth
                        />
                      )}
                    />

                    <div className={classes.divActionButton}>
                      <RefreshRounded className={classes.iconAcctionInventory}
                        onClick={fechFingerPrints}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <InputSelectMembershipType
                text={membershipType}
                setValue={setMembershipType}
                setMembershipValidity={setMembershipValidity}
                label={"Tipo de membrecía"}
                options={allMembershipType}
                isRequired={true}
                allDays={allDays}
              />

              <div>
                <div className={classes.divLabel}>
                  <p className={classes.label} >{"Dias de acceso"}</p>
                </div>

                <div style={{ backgroundColor: "#FFFFFF", borderRadius: '4px', }}>
                  <Table className="mb-0">
                    <TableHead>
                      <TableRow className={classesTable.tableServices} >
                        <TableCell>SERVICIO</TableCell>
                        <TableCell>DÍAS SEMANA</TableCell>
                        <TableCell># DE DÍAS</TableCell>
                        {/*{keys.map(key => (
                            <TableCell key={key}>{key}</TableCell>
                        ))}*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {membershipType.services.map(({ serviceName, numberOfDays, days, isAllSelected }) => (
                        <TableRow>
                          <TableCell className={classesTable.tableServicesTextStyle} >{serviceName}</TableCell>

                          <TableCell className={classesTable.tableServicesTextStyle} >
                            <FormControl className={classes.formControl}>
                              {numberOfDays == 7 ? (
                                <>
                                  <p style={{ color: "#000000" }}>L, M, M, J, V, S, D</p>
                                </>
                              ) : (
                                <>
                                  <Select
                                    labelId="mutiple-select-label"
                                    multiple
                                    value={days}
                                    onChange={handleChangeDays(serviceName).bind(this)}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    style={{ color: "#000000" }}
                                  >
                                    <MenuItem
                                      value="all"
                                      classes={{
                                        root: isAllSelected ? classes.selectedAll : ""
                                      }}
                                    >
                                      <ListItemIcon>
                                        <Checkbox
                                          classes={{ indeterminate: classes.indeterminateColor }}
                                          checked={isAllSelected}
                                          indeterminate={
                                            days.length > 0 && days.length <= allDays.length
                                          }
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        classes={{ primary: classes.selectAllText }}
                                        primary="Seleccionar todos"
                                      />
                                    </MenuItem>
                                    {allDays.map((option) => (
                                      <MenuItem key={option.name} value={option.name}>
                                        <ListItemIcon>
                                          <Checkbox checked={days.indexOf(option.name) > -1} />
                                        </ListItemIcon>
                                        <ListItemText primary={option.name} />
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </>
                              )}
                            </FormControl>
                          </TableCell>

                          <TableCell className={classesTable.tableServicesTextStyle} >{numberOfDays + " días"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>

              <InputSelect
                text={partnerType}
                setValue={setPartnerType}
                label={"Tipo de socio"}
                options={allPartnerType}
                isRequired={false}
              />

              <SwitchPrincipalPartner
                value={paidInscription}
                setValue={setPaidInscription}
                label="¿Hizo el pago de inscripción?"
              />

              <div>
                <label className={classesTravelerSwitch.label} >{"¿Usuario viajero?"}</label>
                <div className={classesTravelerSwitch.divSwitch}>
                  <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                  <Switch
                    checked={isTraveler}
                    onChange={handleChangeTraveler}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                </div>
              </div>
            </div>

            <div className={classes.divColumn}>
              {groupType.discount > 0 && membershipType.text != '' ? (
                <>
                  <div className={classes.divgroupTypeAndPrice}>
                    <label className={classes.priceTitleStyle}>{"Precio: "}</label>
                    {paidInscription ? (
                      <>
                        {isTraveler ? (
                          <label className={classes.priceTitleStyle}
                            style={{
                              textDecorationLine: 'line-through', fontWeight: '200',
                              fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                            }}>{currencyFormat(Number(membershipType.cost) + Number(costInscription) + Number(costTraveler))}</label>
                        ) : (
                          <label className={classes.priceTitleStyle}
                            style={{
                              textDecorationLine: 'line-through', fontWeight: '200',
                              fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                            }}>{currencyFormat(Number(membershipType.cost) + Number(costInscription))}</label>
                        )}
                      </>
                    ) : (
                      <>
                        {isTraveler ? (
                          <label className={classes.priceTitleStyle}
                            style={{
                              textDecorationLine: 'line-through', fontWeight: '200',
                              fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                            }}>{currencyFormat(Number(membershipType.cost) + Number(costTraveler))}</label>
                        ) : (
                          <label className={classes.priceTitleStyle}
                            style={{
                              textDecorationLine: 'line-through', fontWeight: '200',
                              fontSize: '20px', color: '#C9C9C9', marginLeft: '6px'
                            }}>{currencyFormat(membershipType.cost)}</label>
                        )}
                      </>
                    )}

                    {groupType.isDiscountByPercent ? (
                      <>
                        {paidInscription ? (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat((Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100) + Number(costInscription) + Number(costTraveler))}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat((Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100) + Number(costInscription))}</label>
                            )}
                          </>
                        ) : (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat((Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100) + Number(costTraveler))}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat(Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100)}</label>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {paidInscription ? (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat((Number(membershipType.cost) - Number(groupType.discount)) + Number(costInscription) + Number(costTraveler))}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat((Number(membershipType.cost) - Number(groupType.discount)) + Number(costInscription))}</label>
                            )}
                          </>
                        ) : (
                          <>
                            {isTraveler ? (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat((Number(membershipType.cost) - Number(groupType.discount)) + Number(costTraveler))}</label>
                            ) : (
                              <label className={classes.priceTitleStyle}
                                style={{ marginLeft: '8px', color: '#3CD4A0' }}
                              >{currencyFormat(Number(membershipType.cost) - Number(groupType.discount))}</label>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {membershipType.text != '' ? (
                    <>
                      <div className={classes.divTitle}>
                        {groupType.isDiscountByPercent ? (
                          <>
                            {paidInscription ? (
                              <>
                                {isTraveler ? (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat((Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100) + Number(costInscription) + Number(costTraveler))}</label>
                                ) : (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat((Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100) + Number(costInscription))}</label>
                                )}
                              </>
                            ) : (
                              <>
                                {isTraveler ? (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat((Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100) + Number(costTraveler))}</label>
                                ) : (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat(Number(membershipType.cost) - (Number(membershipType.cost) * (Number(groupType.discount))) / 100)}</label>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {paidInscription ? (
                              <>
                                {isTraveler ? (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat((Number(membershipType.cost) - Number(groupType.discount)) + Number(costInscription) + Number(costTraveler))}</label>
                                ) : (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat((Number(membershipType.cost) - Number(groupType.discount)) + Number(costInscription))}</label>
                                )}
                              </>
                            ) : (
                              <>
                                {isTraveler ? (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat((Number(membershipType.cost) - Number(groupType.discount)) + Number(costTraveler))}</label>
                                ) : (
                                  <label className={classes.priceTitleStyle}>{"Precio: " + currencyFormat(Number(membershipType.cost) - Number(groupType.discount))}</label>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className={classes.divTitle}>
                      <label className={classes.priceTitleStyle}>{"Precio: $ 0.00"}</label>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <div className={classes.divButton}>
            {isLoading ? (
              <div className={classes.loginLoader} >
                <CircularProgress size={26} />
              </div>
            ) : (
              <>
                <button
                  className={name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
                    && fingerPrint.valid === 'true' ?
                    classes.enableButton : classes.disableButton}
                  disabled={!(name.valid === 'true' && lastName.valid === 'true' && membershipType.valid === 'true'
                    && fingerPrint.valid === 'true')}
                  onClick={onAddPartner}
                >{isEdit ? "MODIFICAR" : "AGREGAR"}</button>

                <button
                  className={partners.length > 2 ?
                    classes.enableButton : classes.disableButton}
                  disabled={!(partners.length > 2)}
                  onClick={onSubmit}
                >GUARDAR</button>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default AddGroupPartnerForm;